import { render, staticRenderFns } from "./ShowContact.vue?vue&type=template&id=982136f6&scoped=true"
import script from "./ShowContact.vue?vue&type=script&lang=js"
export * from "./ShowContact.vue?vue&type=script&lang=js"
import style0 from "./ShowContact.vue?vue&type=style&index=0&id=982136f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982136f6",
  null
  
)

export default component.exports